module.exports = __webpack_public_path__ + "static/62gde-4da8a432c7a82cc128dac2ecb3335382.gif";